import type { EditorPreviewCardEntry } from '@source-components-react/types';
import { ComponentIdentifiers } from '@source-components-react/component-identifiers';

export const previewCardEntry: EditorPreviewCardEntry = {
  id: ComponentIdentifiers.rDivider,
  // The heavy box-drawing horizontal rather than the light one: the palette
  // draws these at 24px in a muted grey, where a hairline glyph reads as a
  // rendering artefact instead of as the rule the component draws.
  icon: '━',
  label: 'Divider',
};
